import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Paypal from "./Payments/Paypal.component";
import { useSelector } from 'react-redux';
import Cookies from "js-cookie";

export default function SingleNotification(props) {

    let navigate = useNavigate();

    const [isPaid, setisPaid] = useState(false);
    // react-bootstrap
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Redux State
    const userData = useSelector(state => state.auth.data);

    let metatags = props?.item?.metadata?.split("&");
    let notifyUrl = {
        post_id: parseInt(metatags[0]?.split("=")[1]),
        bid_id: metatags[1]?.split("=")[0].includes("bid_id") ? parseInt(metatags[1]?.split("=")[1]) : null,
        service_id: metatags[1]?.split("=")[0].includes("service_id") ? parseInt(metatags[1]?.split("=")[1]) : null,
    }

    const handlePaymentCheck = (e) => {
        e.preventDefault();
        if (userData?.role == 3 && props.item.details.customer_id == userData?.id) {            
            return navigate(`/jobs/${props?.item.details.id}`, { replace: true });
        }
        else {
            // isPaid ? 
            // navigate(`/jobs/${props?.post?.id}`, { replace: true }) :
            if (props.item.details.id == Cookies.get(`jobid${props.item.details.id}`) && Cookies.get(`isPaid${props.item.details.id}`) == "paid") {
                // console.log("job id Found & user is paid");
                navigate(`/jobs/${props?.item.details.id}`, { replace: true })
            } else if (props.item.details.assign_post !== null) {
                Object.keys(props.item.details.assign_post).length > 0 && props.item.details.assign_post.user_id === userData?.id &&
                    navigate(`/jobs/${props?.item.details.id}`, { replace: true })
            } else {
                handleShow();
            }
        }
    };

    return (
        <>
            <div className="bds-box">
                <div className="bds-cardtitle">
                    <h4 className="">
                        {props?.item?.notification_text}
                    </h4>
                    <h6 className="text-sky-blue mb-3">{props?.item?.details?.service?.service_name}</h6>
                    <h6>{props?.item?.details?.title}</h6>
                    <p>{props?.item?.details?.description}</p>
                </div>
                {
                    notifyUrl?.post_id && notifyUrl?.bid_id &&
                    <Link to={`/bids?${props?.item?.metadata}`} className="bds-btn-solid mt-3 me-2">View Proposals
                    </Link>
                }
                {
                    (notifyUrl?.post_id || notifyUrl?.service_id) &&
                    <Link to={`#`} onClick={(e) => handlePaymentCheck(e)} className="bds-btn-solid mt-3">View Detail
                    </Link>
                }
            </div>
            {/* <!-- Modal --> */}
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header className="border-0" closeButton></Modal.Header>
                <Modal.Body className="p-4">
                    <h3>Please Pay </h3>
                    <Paypal
                        job={props?.item.details}
                        redirectURL={`/jobs/${props?.item.details.id}`}
                        setisPaid={setisPaid}
                        handleClose={handleClose}
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}
